// extracted by mini-css-extract-plugin
export default {"backdrop__active":"bARmRp0","close":"k0JZvlI ZqXYTuz","results":"bueqJYo"};